<template>
  <div class="bank-conditions">
    <h3>Ihre Zahlart</h3>
    <div class="bank-conditions__payment-wrapper">
      <div class="bank-conditions__payment bank-conditions__form">
        <label>
          <input type="radio" checked />
          Online-Finanzierung bei Bank11
        </label>
        <div class="bank-conditions__image-wrap">
          <img src="../assets/images/bank11.png" alt="Bank11" />
        </div>
      </div>
      <div class="bank-conditions__financing-info">
        <div class="bank-conditions__financing-info-item">
          <span>Vertragslaufzeit</span>
          <span v-if="financingDetails.term">{{ financingDetails.term }} Monate</span>
          <span v-else>Loading...</span>
        </div>
        <div class="bank-conditions__financing-info-item">
          <span>Einmalige Anzahlung</span>
          <span v-if="financingDetails.deposit !== undefined">{{ formattedPrice(financingDetails.deposit) }}</span>
          <span v-else>Loading...</span>
        </div>
        <div class="bank-conditions__financing-info-item">
          <span>Monatliche Rate à</span>
          <span v-if="financingDetails.monthlyRate">{{ formattedPrice(financingDetails.monthlyRate) }}</span>
          <span v-else>Loading...</span>
        </div>
        <div class="bank-conditions__financing-info-item" v-if="financingDetails.ballonAmount">
          <span>Schlussrate (letzte Rate)</span>
          <span v-if="financingDetails.ballonAmount">{{ formattedPrice(financingDetails.ballonAmount) }}</span>
          <span v-else>Loading...</span>
        </div>
        <div class="bank-conditions__financing-info-item">
          <span>Nettodarlehensbetrag</span>
          <span v-if="car && financingDetails.deposit !== undefined">
            {{ formattedPrice(order.car_info.price.customer - financingDetails.deposit) }}
          </span>
          <span v-else>Loading...</span>
        </div>
        <div class="bank-conditions__financing-info-item">
          <span>
            Darlehensgesamtbetrag <br />
            ( {{ financingDetails.interestRate }}% Effektiver Jahreszins)
          </span>
          <span v-if="financingDetails.total">{{ formattedPrice(financingDetails.total) }}</span>
          <span v-else>Loading...</span>
        </div>
      </div>
      <div class="bank-conditions__financing-price">
        <span class="financing-price__description">
          <b>Übrigens:</b> Sie können die Rate später nochmal anpassen
        </span>
        <div class="financing-price__details">
          <span class="price" v-if="financingDetails.monthlyRate">{{ formattedPrice(financingDetails.monthlyRate) }}</span>
          <span class="months" v-if="financingDetails.term">Monatliche Rate</span>
          <span class="months" v-else>Loading...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPrice } from '../utils/price-helpers';
import { getFinancingPlans } from '../api/financing';

export default {
  props: ['car'],
  data() {
    const { term, deposit } = this.$route.query;
    const { customer: price } = this.order.car_info.price;

    return {
      currentFinancingPlan: {},
      isSharedFinancingPlan: !!term && !!price && !!deposit,
    };
  },
  created() {
    const { term, deposit, ballonAmount: urlBallonAmount } = this.$route.query;
    const { customer: price } = this.order.car_info.price;

    if (this.isSharedFinancingPlan) {
      getFinancingPlans(price, deposit).then(res => {
        const { ballonAmount, withoutBallonAmount } = this.filterResponseData(res);
        const currentPlan = urlBallonAmount ? ballonAmount : withoutBallonAmount;
        const result = currentPlan.find(item => item.term === +term);
        this.currentFinancingPlan = result;
      });
    }
  },
  computed: {
    financingDetails() {
      if (!this.car) {
        return {};
      }

      const {
        initial_financing_offer: {
          down_payment,
          final_installment,
          financing_amount,
          interest_rate,
          monthly_rate,
          term,
          total_amount
        }
      } = this.car;

      const {
        ballonAmount,
        deposit,
        effectiveInterest,
        installment,
        term: financingTerm,
        total
      } = this.currentFinancingPlan;

      const isSharedPlan = this.isSharedFinancingPlan;

      return {
        financingAmount: financing_amount,
        term: isSharedPlan ? financingTerm : term,
        total: isSharedPlan ? total : total_amount,
        deposit: isSharedPlan ? deposit : down_payment,
        monthlyRate: isSharedPlan ? installment :monthly_rate,
        ballonAmount: isSharedPlan ? ballonAmount : final_installment,
        interestRate: isSharedPlan ? effectiveInterest : interest_rate,
      };
    },
  },
  methods: {
    formattedPrice(num) {
      return `€ ${formatPrice(num)} ,-`;
    },
    filterResponseData(res) {
      const ballonAmount = [];
      const withoutBallonAmount = [];

      res.forEach(item => {
        if (item.ballonAmount === 0) {
          withoutBallonAmount.push(item);
        } else {
          ballonAmount.push(item);
        }
      });

      return { ballonAmount, withoutBallonAmount };
    },
  },
};
</script>

<style lang="scss" scoped>
.bank-conditions {
  padding: 1.25rem 0.625rem;;
  h3 {
    margin-bottom: 0.3125rem;
    font-size: 0.75rem;
    font-weight: 700;
  }
  &__form {
    margin-bottom: 1.0625rem;
    padding: 0.9375rem 1.5625rem 0 2.5rem;
    border: 0.0625rem solid #e5e5e5;
    label {
      position: relative;
      display: block;
      margin-bottom: 0.9375rem;
      font-size: 0.75rem;
      font-weight: 700;

      &:last-child {
        border-top:1px solid #dadada;
        padding-top: 1rem;
      }

      &:hover {
        cursor: pointer;
      }
      p {
        font-weight: 400;
      }
      input {
        position: absolute;
        left: -1.875rem;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  &__payment {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0.9375rem;
    label {
      margin: 0;
    }

    &-wrapper {
      border: 0.0625rem solid #dadada;
      margin-bottom: 1.0625rem;

      .bank-email-form__payment {
        border: none;
        margin-bottom: 0;
      }
    }
  }

  &__financing-info {
    padding: 0 0 25px 40px;
    font-size: 14px;

    &-item {
      &:last-child {
        display: flex;
        border-top:1px solid #dadada;
        margin-top: 1rem;
        padding-top: 1rem;
        margin-right: 1rem;

        span {
          line-height: 20px;
        }
      }
      span {
        display: inline-block;
        line-height: 24px;

        &:first-child {
          min-width: 180px;
        }
      }
    }
  }

  &__financing-price {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 23px 0;
    margin: 0 15px;
    border-top: 1px solid #d8d8d8;

    .financing-price__description {
      color: #43b69b;
      font-size: 12px;
      line-height: 16px;

      b {
        font-weight: 600;
      }
    }

    .financing-price__details {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      color: #67259f;

      .price {
        font-size: 18px;
        font-weight: 700;
      }

      .months {
        font-size: 12px;
        line-height: 14px;
        white-space: nowrap;
      }
    }
  }

  &__image-wrap {
    position: relative;
    width: 3.75rem;
    img {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 80%;
      transform: translate(-50%, -50%);
      box-sizing: border-box;
    }
  }
  @include breakpoint(tablet) {
    padding: 0 1.875rem 0.0625rem;
    margin-bottom: 1.875rem;
    background-color: $white;
  }
  @include breakpoint(desktop) {
    margin-bottom: 0;
    h3 {
      font-size: 0.875rem;
    }
    &__form {
      label {
        font-size: 0.875rem;
      }
    }
  }

  @include breakpoint(desktop) {
    padding-bottom: 1rem;
  }
}
</style>
